import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

const Impressum = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-slate-50 py-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        {/* Back Button */}
        <Button
          variant="ghost"
          onClick={onBack}
          className="mb-8 text-teal-600 hover:text-teal-700 hover:bg-teal-50"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Button>

        <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
          <h1 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-8">
            Impressum
          </h1>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">
              Angaben gemäß § 5 TMG:
            </h2>
            
            <p className="text-slate-700 mb-6">
              <strong>ADMIN Hausverwaltung</strong><br />
              Inh. Bärbel Paul
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">
              Postanschrift:
            </h3>
            <p className="text-slate-700 mb-6">
              Domblick 24 c<br />
              39175 Gerwisch
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">
              Kontakt:
            </h3>
            <p className="text-slate-700 mb-6">
              Telefon (Handy): 0171 7431533<br />
              E-Mail: baerbel.paul@admin-hausverwaltung.de<br />
              Website: www.admin-hausverwaltung.de
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">
              Vertreten durch:
            </h3>
            <p className="text-slate-700 mb-6">
              Bärbel Paul
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">
              Firmensitz:
            </h3>
            <p className="text-slate-700 mb-6">
              Gerwisch
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">
              Finanzbehörde:
            </h3>
            <p className="text-slate-700 mb-6">
              Genthin
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">
              Steuernummer:
            </h3>
            <p className="text-slate-700 mb-6">
              103/255/01524
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">
              Gewerbeerlaubnis:
            </h3>
            <p className="text-slate-700 mb-6">
              nach § 34c GewO der Landeshauptstadt Magdeburg,<br />
              Bei der Hauptwache 4<br />
              39104 Magdeburg
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">
              Urheberrechtliche Hinweise:
            </h3>
            <p className="text-slate-700 mb-6">
              Die Inhalte dieser Website sind urheberrechtlich geschützt. 
              Jede Verwertung außerhalb der engen Grenzen des Urheberrechtsgesetzes 
              ist ohne Zustimmung des Autors unzulässig und strafbar.
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3">
              Haftungsausschluss:
            </h3>
            <p className="text-slate-700 mb-6">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung 
              für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten 
              sind ausschließlich deren Betreiber verantwortlich.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
